export const FileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const data = (reader.result as string).split(",")[1];
            resolve(data);
        };
        reader.onerror = (e: any) => {
            console.error("error while converting file to base-64", e);
            reject(e);
        };
        reader.readAsDataURL(file);
    });
};

export const DownloadBlob = (fileName: string, blob: Blob) => {
    // For Microsoft Edge
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
        const url = (window.URL ? URL : webkitURL).createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";
        a.href = url;
        a.download = fileName;
        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }
};

export const ShowBlobOnNewtab = (fileName: string, blob: Blob) => {
    // For Microsoft Edge
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
        const url = (window.URL ? URL : webkitURL).createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";
        a.textContent = fileName;
        a.href = url;
        a.target = "_blank";
        a.click();

        window.URL.revokeObjectURL(url);
        console.log(a);
        document.body.removeChild(a);
    }
};

export const CopyReportIframe = (iframeElement: HTMLIFrameElement | null) => {
    if (!iframeElement) {
        return;
    }
    const iframe = iframeElement;
    const selection = iframe.contentWindow!.getSelection();
    const range = iframe.contentDocument!.createRange();
    range.selectNodeContents(iframe.contentDocument!.body);
    selection!.removeAllRanges();
    selection!.addRange(range);
    iframe.contentDocument!.execCommand("copy");
};

export const PrintReportIframe = (iframeElement: HTMLIFrameElement | null) => {
    if (!iframeElement) {
        return;
    }
    iframeElement.focus();
    iframeElement.contentWindow!.print();
};

//
// How did these guys end up in FileUtil? we should create a separate utility module for these at some point...
//

export const ConvertToCents = (amount: string) => Math.round(parseFloat(amount.replace(/,/g, "")) * 100);

export const NumberToMonetaryStringFormat = (num: number) => {
    var str = (num / 100)
        .toFixed(2)
        .toString()
        .split(".");
    if (str[0].length >= 5) {
        str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, "$1,");
    }
    if (str[1] && str[1].length >= 5) {
        str[1] = str[1].replace(/(\d{3})/g, "$1 ");
    }
    return str.join(".");
};

export const CovertAndFormatCentsToDollars = (monetaryValue: number): string => {
    return (monetaryValue / 100).toLocaleString("en-CA", { style: "currency", currency: "CAD" }).replace(/\$/g, "");
};

export const CovertAndFormatCentsToDollarsWithDollarSign = (monetaryValue: number): string => {
    return (monetaryValue / 100).toLocaleString("en-CA", { style: "currency", currency: "CAD" });
};

export const FormatDollarString = (amount: string) => parseFloat(amount).toLocaleString("en-CA", { style: "currency", currency: "CAD" });



// WEBPACK FOOTER //
// ./src/common/Methods/FileUtil.ts